import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function MusicPage() {
  return <AppPagePlaceholder name="Music" />;
}
